angular.module('iqxCore')
  .service('ApplicationSvc', function ($http, $window, $cookies, $location, $uibModal, LanguageSvc) {
    var svc = this
    svc.isLoggedIn = false
    svc.appMode = $cookies.getObject('appMode') // this is for the custom app landing page
    svc.isApp = isApp() // this determines if we are using the app wrapper or not!
    svc.currentUser = {}
    svc.postLoginRoute = '/'
    svc.isEditing = false
    svc.preventNavIfEditing = false
    svc.cookieOptions = {
      'expires': moment().add(1, 'y').toDate()
    }

    // Login logic has moved: 
    // initSessionSvc (initSession.svc.js) Handles all the Login/Session Restore logic

    svc.params = {
      BROWSERTITLE: '',
      HEADERNAME: '',
      FOOTERTEXT: '',
      LOGOFILE: '',
      LOGOALT: '',
      GOOGLEANALYTICS: false,
      lang: LanguageSvc.lang, 
      SHOWNEWVERSIONWARN: false,
      DEVMODE: false,
      INACTIVITYTIMER: 10,
      USETEMPSESSIONS: false,
      behaviour: {}
    }

    svc.checkPermissions = function ($userClass, permissions) {
      permissions = permissions || []
      var noPermission = []

      if (svc.currentUser.UserClass == $userClass) {
        // They have the correct user class - Check permissions
        angular.forEach(permissions, function (v, k) {
          if (svc.currentUser.UserRights.indexOf(v) === -1) {
            noPermission.push(v)
          }
        })

        if (noPermission.length != 0) {
          // one or more permissions failed!
          $location.url('/noPermission') // they don't, redirect them away!!
          return false
        } else {
          return true
        }
      } else {
        $location.path('/noPermission') // they don't, redirect them away!!
        return false
      }
    }

    svc.checkRights = function (rights) {
      var rights = rights || []
      var noPermission = []

      // They have the correct user class - Check permissions
      angular.forEach(rights, function (v, k) {
        if (svc.currentUser.UserRights.indexOf(v) === -1) {
          noPermission.push(v)
        }
      })

      if (noPermission.length != 0) {
        // one or more permissions failed!
        return false
      } else {
        return true
      }
    }

    svc.isSwitchedOn = function (xSwitch) {
      return (svc.currentUser.Switches && svc.currentUser.Switches.indexOf(xSwitch) >= 0)
    }

    svc.changePassword = function (Data) {
      svc.currentUser.token = Data.token
      svc.currentUser.forceChangePassword = false
      $http.defaults.headers.common['X-Auth'] = Data.token
      if (svc.params.USETEMPSESSIONS) {
        $window.sessionStorage.setItem('IQXSession', JSON.stringify(svc.currentUser)) // Replace persistent login details
      } else {
        $cookies.putObject('IQXSession', svc.currentUser, svc.cookieOptions)
      }
    }

    svc.navigate = function (path) {
      svc.openedModalDialog = undefined  // If path change is in a then chain after a modal dialog, openedModalDialog may not yet have been unset which will block navigation. This forces it.
      $location.url(path)
    }

    svc.openDialog = function (options, onOpenCallBack) { // This wrapper is allow routes.js to trap 'Back' navigation to dismiss a dialog
      onOpenCallBack = onOpenCallBack || {}
      svc.openedModalDialog = $uibModal.open(options)
      svc.openedModalDialog.opened.then(onOpenCallBack)
      svc.openedModalDialog.closed.then(function () { svc.openedModalDialog = undefined })
      return svc.openedModalDialog.result
    }

    svc.messageDialog = function (caption, message, okText, cancelText, bSucceedIfCancel, bDanger) {
      return svc.openDialog({
        templateUrl: 'views/modalDialog.html',
        size: 'sm',
        backdrop: 'static',
        controller: 'ModalCtrl',
        windowClass: bDanger ? 'text-danger' : '',
        resolve: {
          getModalVars: function () {
            return { title: caption, text: message, yesText: okText, noText: cancelText, succeedIfCancel: bSucceedIfCancel }
          }
        }
      })
    }

    svc.showMessage = function (caption, message, bError) {
      return svc.messageDialog(caption, message, 'Ok', '', false, bError)
    }

    svc.queryMessage = function (caption, message, okCancel) {
      if (okCancel) {
        return svc.messageDialog(caption, message, 'Ok', 'Cancel')
      } else {
        return svc.messageDialog(caption, message, 'Yes', 'No')
      }
    }

    svc.forceChangePassword = function () {
      return svc.currentUser.forceChangePassword
    }

    svc.appIsEditing = function () {  // Used by questionnaire because the broadcast method was unreliable and easily circumvented
      return svc.isEditing
    }

    svc.ScrollToElement = function (id) {
      var target = document.getElementById(id)
      target.scrollIntoView()
    }

    function isApp() {
      return $cookies.getObject('isApp')
    }

    // to calculate width of bulletin body. 
		// needed to determine whether to show the 'read more' button for candidate and user bulletins
		svc.widths = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.2796875,0.2765625,0.3546875,0.5546875,0.5546875,0.8890625,0.665625,0.190625,0.3328125,0.3328125,0.3890625,0.5828125,0.2765625,0.3328125,0.2765625,0.3015625,0.5546875,0.5546875,0.5546875,0.5546875,0.5546875,0.5546875,0.5546875,0.5546875,0.5546875,0.5546875,0.2765625,0.2765625,0.584375,0.5828125,0.584375,0.5546875,1.0140625,0.665625,0.665625,0.721875,0.721875,0.665625,0.609375,0.7765625,0.721875,0.2765625,0.5,0.665625,0.5546875,0.8328125,0.721875,0.7765625,0.665625,0.7765625,0.721875,0.665625,0.609375,0.721875,0.665625,0.94375,0.665625,0.665625,0.609375,0.2765625,0.3546875,0.2765625,0.4765625,0.5546875,0.3328125,0.5546875,0.5546875,0.5,0.5546875,0.5546875,0.2765625,0.5546875,0.5546875,0.221875,0.240625,0.5,0.221875,0.8328125,0.5546875,0.5546875,0.5546875,0.5546875,0.3328125,0.5,0.2765625,0.5546875,0.5,0.721875,0.5,0.5,0.5,0.3546875,0.259375,0.353125,0.5890625]
		svc.avg = 0.5279276315789471

    		// measures the length(ish) in px of a string
    svc.measureText = function (str) {
			return Array.from(str).reduce((acc, cur) => {
			  var _widths$cur$charCodeA;
			  return acc + ((_widths$cur$charCodeA = svc.widths[cur.charCodeAt(0)]) !== null && _widths$cur$charCodeA !== void 0 ? _widths$cur$charCodeA : svc.avg);
			}, 0) * 18;
		  }


  })
  .controller('ModalCtrl', function ($scope, getModalVars) {
    $scope.xModal = getModalVars

    $scope.cancel = function () {
      if ($scope.xModal.succeedIfCancel) {
        $scope.$close(false)
      } else {
        $scope.$dismiss()
      }
    }
  })
